<template>
    <div id="todo-print-book">
        <h2>LOREM IPSUM</h2>
        <p>Puzzle, etc. a renvoyer sur le form groupe-santerre</p>
    </div>
</template>

<script>
export default {
    name: "TodoPrintBook",
};
</script>

<style scoped>

</style>